"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useImmer3 = require("use-immer");
var _Icons = require("../../Icons");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
var _edSystem = require("@eduact/ed-system");
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _modifiers = require("@dnd-kit/modifiers");
var _Question = require("../Question.styled");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OrderingQuestion = function OrderingQuestion(_ref) {
  var question = _ref.question,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeId = _useState2[0],
    setActiveId = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var _useImmer = (0, _useImmer3.useImmer)(!question.answer ? question.options.map(function (option, index) {
      return {
        option: option,
        id: "".concat(index + 1)
      };
    }) : question.answer.map(function (option, index) {
      return {
        option: option,
        id: "".concat(index + 1)
      };
    })),
    _useImmer2 = _slicedToArray(_useImmer, 2),
    values = _useImmer2[0],
    setValues = _useImmer2[1];
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.MouseSensor), (0, _core.useSensor)(_core.PointerSensor), (0, _core.useSensor)(_core.KeyboardSensor, {
    coordinateGetter: _sortable.sortableKeyboardCoordinates
  }));
  var handleDragStart = function handleDragStart(event) {
    var active = event.active;
    var _active = values.find(function (_) {
      return _.id === active.id;
    });
    setActive(_active);
    setActiveId(active.id);
  };
  var handleOnDragEnd = function handleOnDragEnd(event) {
    var active = event.active,
      over = event.over;
    if (!(over !== null && over !== void 0 && over.id)) return;
    if (active.id !== over.id) {
      var oldIndex = values.findIndex(function (_) {
        return _.id === active.id;
      });
      var newIndex = values.findIndex(function (_) {
        return _.id === over.id;
      });
      var items = reorder(values, oldIndex, newIndex);
      onChange(items.map(function (item) {
        return item.option;
      }));
      setValues(items);
    }
    setActiveId(null);
    setActive(null);
  };
  var reorder = function reorder(list, startIndex, endIndex) {
    var result = Array.from(list);
    var _result$splice = result.splice(startIndex, 1),
      _result$splice2 = _slicedToArray(_result$splice, 1),
      removed = _result$splice2[0];
    result.splice(endIndex, 0, removed);
    return result;
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Question.QuestionContentWrapper, {
    dangerouslySetInnerHTML: {
      __html: question.content
    }
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '0.813rem',
      lg: '2.313rem'
    }
  }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    mb: {
      sm: '1rem',
      lg: '2rem'
    },
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    sensors: sensors,
    onDragStart: handleDragStart,
    collisionDetection: _core.closestCenter,
    autoScroll: true,
    modifiers: [_modifiers.restrictToParentElement, _modifiers.restrictToVerticalAxis],
    onDragEnd: handleOnDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    strategy: _sortable.verticalListSortingStrategy,
    items: values
  }, values.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(DraggableOption, {
      key: "".concat(option.id, "-").concat(index),
      content: option.option,
      id: option.id
    });
  })), /*#__PURE__*/_react["default"].createElement(_core.DragOverlay, {
    dropAnimation: {
      duration: 300,
      easing: 'cubic-bezier(0.65,0.05,0.36,1)'
    }
  }, active ? /*#__PURE__*/_react["default"].createElement(DragOverlayItem, {
    content: active.option
  }) : null))));
};
var _default = OrderingQuestion;
exports["default"] = _default;
var StyledOption = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tborder-radius: 5px;\n\ttouch-action: none;\n\tpadding: 5px 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 8px;\n\twidth: fit-content;\n\tcursor: pointer;\n\t", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tmargin-bottom: 1.5rem;\n        padding: 0.5rem 1rem;\n    }");
});
var StyledDraggableOption = (0, _styledComponents["default"])(StyledOption)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground-color: #f6f6f6;\n\tbackground-color: ", ";\n\topacity: ", ";\n"])), function (props) {
  return props.isDragged && '#e1e0ff';
}, function (_ref3) {
  var isDragged = _ref3.isDragged;
  return isDragged && '0.2';
});
var DraggableOption = function DraggableOption(_ref4) {
  var content = _ref4.content,
    id = _ref4.id;
  var _id = (0, _react.useMemo)(function () {
    return id;
  }, []);
  var _useSortable = (0, _sortable.useSortable)({
      id: _id
    }),
    isDragging = _useSortable.isDragging,
    setNodeRef = _useSortable.setNodeRef,
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    transition = _useSortable.transition,
    transform = _useSortable.transform;
  var style = {
    transform: "translate(".concat(transform === null || transform === void 0 ? void 0 : transform.x, "px,").concat(transform === null || transform === void 0 ? void 0 : transform.y, "px)"),
    zIndex: isDragging ? '4' : '',
    transition: transition
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDraggableOption, _extends({
    ref: function ref(e) {
      setNodeRef(e);
    },
    isDragged: isDragging,
    style: style
  }, attributes, listeners), /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "purpleNavy"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.SwapVertically, null)), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mx: "0.25rem"
  }), /*#__PURE__*/_react["default"].createElement("span", null, content)));
};
var DragOverlayItem = function DragOverlayItem(_ref5) {
  var content = _ref5.content;
  return /*#__PURE__*/_react["default"].createElement(StyledDragOverlay, null, /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "purpleNavy"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.SwapVertically, null)), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mx: "0.25rem"
  }), /*#__PURE__*/_react["default"].createElement("span", null, content));
};
var StyledDragOverlay = (0, _styledComponents["default"])(StyledOption)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground-color: #e1e0ff;\n\twhite-space: nowrap;\n"])));